<template>
    <base-modal
        class="modal-rating-core"
        :class="{
            'modal-rating-core--completed': isCompleted,
        }"
        :open="isOpenRating"
        @close="onCloseModalDebouncing"
        :controlled="true"
        :unmountAfterMs="unmountAfterMs">
        <div class="modal-rating" id="modal-rating">
            <div class="modal-rating__image">
                <img
                    src="@assets/images/logo/hyperlead-logo.png"
                    alt="HyperLead Branding" />
            </div>

            <form @submit.prevent="onSubmitRate" class="modal-rating__content">
                <alert
                    v-if="ratingError.isError"
                    class="mb-4 text-left"
                    color="danger">
                    <div v-html="$t('components.modalRating.error')"></div>
                </alert>

                <h2
                    class="modal-rating__content__title mb-2"
                    v-html="
                        isCompleted
                            ? $t('components.modalRating.thankTitle')
                            : $t('components.modalRating.title')
                    "></h2>
                <h2
                    class="modal-rating__content__subtitle mb-4"
                    v-html="
                        isCompleted
                            ? $t('components.modalRating.thankSubtitle')
                            : $t('components.modalRating.subtitle')
                    "></h2>

                <div
                    v-if="!isCompleted"
                    class="modal-rating__content__reaction">
                    <reaction
                        @click="onReaction('so-bad', 1)"
                        :focused="
                            reactionSelected === 'all'
                                ? true
                                : reactionSelected === 'so-bad'
                        "
                        class="
                            modal-rating__content__reaction__item
                            cursor-pointer
                        "
                        type="so-bad" />
                    <reaction
                        @click="onReaction('bad', 2)"
                        :focused="
                            reactionSelected === 'all'
                                ? true
                                : reactionSelected === 'bad'
                        "
                        class="
                            modal-rating__content__reaction__item
                            cursor-pointer
                        "
                        type="bad" />
                    <reaction
                        @click="onReaction('normal', 3)"
                        :focused="
                            reactionSelected === 'all'
                                ? true
                                : reactionSelected === 'normal'
                        "
                        class="
                            modal-rating__content__reaction__item
                            cursor-pointer
                        "
                        type="normal" />
                    <reaction
                        @click="onReaction('okay', 4)"
                        :focused="
                            reactionSelected === 'all'
                                ? true
                                : reactionSelected === 'okay'
                        "
                        class="
                            modal-rating__content__reaction__item
                            cursor-pointer
                        "
                        type="okay" />
                    <reaction
                        @click="onReaction('good', 5)"
                        :focused="
                            reactionSelected === 'all'
                                ? true
                                : reactionSelected === 'good'
                        "
                        class="
                            modal-rating__content__reaction__item
                            cursor-pointer
                        "
                        type="good" />
                </div>

                <div
                    v-if="collapsed && !isCompleted"
                    class="modal-rating__content__feedback mt-2">
                    <h4 class="modal-rating__content__feedback__title">
                        {{ $t("components.modalRating.feedbackTitle") }}
                    </h4>
                    <div
                        class="
                            modal-rating__content__feedback__options
                            mx-auto
                            flex flex-wrap
                            mt-2
                        ">
                        <div class="w-1/2 mb-2">
                            <vs-checkbox
                                v-model="rating.options"
                                vs-value="ui"
                                >{{
                                    $t("components.modalRating.ui")
                                }}</vs-checkbox
                            >
                        </div>
                        <div class="w-1/2 mb-2">
                            <vs-checkbox
                                v-model="rating.options"
                                vs-value="ux"
                                >{{
                                    $t("components.modalRating.ux")
                                }}</vs-checkbox
                            >
                        </div>
                        <div class="w-1/2 mb-2">
                            <vs-checkbox
                                v-model="rating.options"
                                vs-value="feature"
                                >{{
                                    $t("components.modalRating.feature")
                                }}</vs-checkbox
                            >
                        </div>
                        <div class="w-1/2 mb-2">
                            <vs-checkbox
                                v-model="rating.options"
                                vs-value="support"
                                >{{
                                    $t("components.modalRating.support")
                                }}</vs-checkbox
                            >
                        </div>
                    </div>

                    <vs-textarea
                        v-model="rating.message"
                        class="modal-rating__content__message mt-4 resize-none"
                        rows="2"
                        placeholder="Nhập ý kiến của bạn tại dây" />

                    <Button htmlType="submit" color="primary" class="w-full">{{
                        $t("components.modalRating.submit")
                    }}</Button>
                </div>
            </form>
        </div>
    </base-modal>
</template>

<script>
// You can you ratingService to control this component
// RateService: resources/js/src/core/services/ratingService.js

import BaseModal from "../Modal/BaseModal.vue";
import Reaction from "../Reaction/Reaction.vue";
import Button from "../Button/Button.vue";
import ratingService from "../../core/services/ratingService";
import Alert from "../Alert/Alert.vue";
import _ from 'lodash'

export default {
    name: "modal-rating",

    props: {},

    components: {
        BaseModal,
        Reaction,
        Button,
        Alert,
    },

    data() {
        return {
            reactionSelected: "all",

            collapsed: false,

            rating: {
                options: [],
                ratingScores: null,
                message: "",
            },

            ratingError: {
                isError: false,
            },

            unmountAfterMs: 3000,

            isCompleted: false,
        };
    },

    watch: {
        reactionSelected() {
            if (this.reactionSelected !== "all") {
                this.collapsed = true;
            }
        },
    },

    computed: {
        isOpenRating() {
            return this.$store.state.rating.isOpen;
        },
    },

    methods: {
        /**
         * Change reaction state
         *
         * @param {String} react Reaction
         * @param {Number} ratingScores Level of reaction
         */
        onReaction(react, ratingScores = 1) {
            this.reactionSelected = react;
            this.rating.ratingScores = ratingScores;
        },

        onSubmitRate() {
            this.ratingError.isError =
                this.rating.options.length === 0 ||
                !this.rating.ratingScores ||
                !this.rating.message;

            if (this.ratingError.isError) return;

            this.$site.loading.open("#modal-rating");

            const source = window.location.href;

            ratingService
                .sendUserRating({
                    rating_scores: this.rating.ratingScores,
                    options: this.rating.options,
                    message: this.rating.message,
                    source: source
                })
                .then(() => {
                    ratingService.setDisplayedExpires("month", 2);

                    // Wait close loading after that will remove this modal
                    setTimeout(() => {
                        ratingService.closeRatingModal(false).then(() => {
                            setTimeout(() => {
                                this.onResetDatasets();
                            }, this.unmountAfterMs)
                        });
                    }, 0);

                    this.isCompleted = true;
                })
                .finally(() => {
                    this.$site.loading.close("#modal-rating");
                });
        },

        onCloseModal() {
            this.unmountAfterMs = 200;

            return ratingService.closeRatingModal().then(() => {
                if (ratingService.closeTimes() >= 5) {
                    ratingService.removeCloseTimes();
                }
            }).finally(() => {
                this.onResetDatasets();
                this.$emit("close");
            });
        },

        onCloseModalDebouncing: _.debounce(function() {
            const prevIsCompleted = this.isCompleted;

            this.onCloseModal().then(() => {
                this.isCompleted = prevIsCompleted;
            });

        }, 300),

        onResetDatasets() {
            this.reactionSelected = "all";
            this.collapsed = false;
            this.rating = {
                options: [],
                ratingScores: null,
                message: "",
            };
            this.ratingError = {
                isError: false,
            };
            this.unmountAfterMs = 3000;
            this.isCompleted = false;
        }
    },

    mounted() {
        window.onbeforeunload = () => {
            if(this.isOpenRating) {
                return "Are you sure to leave this page?";
            }
        };

        window.addEventListener("unload", () => {
            if(this.isOpenRating) {
                this.onCloseModal();
            }
        })
    },
};
</script>

<style lang="scss">
.modal-rating-core {
    .modal-rating {
        .modal-rating__image {
            display: block;
            text-align: center;
            padding: 0 0 16px;

            img {
                max-width: 32px;
                width: 100%;
            }

            border-bottom: 1px solid #ebe9f1;
        }

        .modal-rating__content {
            padding: 17px 0;
            text-align: center;

            .modal-rating__content__title {
                color: var(--vs-hex-darkblue);
                font-weight: 500;
                font-size: 18px;
                line-height: 20px;
            }

            .modal-rating__content__subtitle {
                color: var(--vs-hex-gray);
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
            }

            .modal-rating__content__reaction {
                display: flex;
                justify-content: center;
                gap: 20px;

                .modal-rating__content__reaction__item {
                    transition: all 300ms ease;

                    &:hover {
                        transform: translateY(-3px);
                    }
                }
            }

            .modal-rating__content__feedback {
                .modal-rating__content__feedback__title {
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 21px;
                    color: var(--vs-hex-gray);
                }

                .modal-rating__content__feedback__options {
                    max-width: 85%;
                }
            }

            .modal-rating__content__message {
                textarea {
                    resize: none;

                    &:focus {
                        resize: none;
                    }

                    &::placeholder {
                        color: #b9b9c3;
                        font-size: 12px;
                    }
                }
            }
        }
    }

    &--completed {
        .base-modal__backdrop {
            visibility: hidden;
        }

        .base-modal__main {
            top: calc(100% - 120px);
            transform: translate(-50%, -50%) scale(0.85);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Rate/ModalRating.vue